import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../stores";
import { Link } from "react-router-dom";
import ProfileAction from "../stores/actions/profileAction";

function ContactDetails({ getSellerData, getProfileDetails }: any) {
  const { categoryList } = useSelector((state: RootState) => state.category);
  const dispatch = useDispatch()<any>;
  const [mobileModal, setMobileModal] = useState(false);
  const [otp, setOTP] = useState("");

  const handleSubmit = async (id: number, product_view_status: string) => {
    try {
      await dispatch(
        ProfileAction.changeProductViewStatus({
          id: id,
          product_view_status: product_view_status,
        })
      );
      getProfileDetails();
    } catch (error) {
      console.log("Error in Submitting " + error);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center pb-2 pt-2">
        <h5 className="mb-0">Profile Details</h5>
        <Link to="/edit-seller-profile" className="btn btn-primary">
          Edit
        </Link>
      </div>
      <hr className="m-0" />
      <div className="card-body py-2">
        <ul className="list-group list-group-flush">
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-user"></i>
            <span className="fw-medium mx-2">Authorized Rep Name :</span>{" "}
            <span>{getSellerData?.rep_name}</span>
          </li>
          <li className={"list-group-item mb-1"}>
            <div
              className={"d-flex align-items-center justify-content-between"}>
              <div>
                <i className="bx bx-phone"></i>
                <span className="fw-medium mx-2">Contact:</span>
                <span>(+91) {getSellerData?.mobile}</span>
              </div>
            </div>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-envelope"></i>
            <span className="fw-medium mx-2">Email:</span>{" "}
            <span>{getSellerData?.email}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-map"></i>
            <span className="fw-medium mx-2">Address:</span>{" "}
            <span>{getSellerData?.address}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-map"></i>
            <span className="fw-medium mx-2">State:</span>{" "}
            <span>{getSellerData?.stateName}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-map"></i>
            <span className="fw-medium mx-2">District:</span>{" "}
            <span>{getSellerData?.districtName}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-pin"></i>
            <span className="fw-medium mx-2">Pincode:</span>{" "}
            <span>{getSellerData?.pincode}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-check"></i>
            <span className="fw-medium mx-2">GST Number:</span>{" "}
            <span>{getSellerData?.gst_no}</span>
          </li>
          <li className="list-group-item d-flex align-items-center mb-1">
            <i className="bx bx-check"></i>
            <span className="fw-medium mx-2">Account Status:</span>{" "}
            <span
              className={`badge me-1 ${
                getSellerData?.account_status == "ACTIVATE"
                  ? "bg-label-success"
                  : "bg-label-danger"
              }`}>
              {getSellerData?.account_status}
            </span>
          </li>
        </ul>
      </div>

      <div
        className="modal"
        style={{ display: mobileModal ? "block" : "none" }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content modal-sm">
            <form className="needs-validation">
              <div className="modal-header">
                <h5 className="modal-title">Verify Number</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMobileModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-validation">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="mb-3 row">
                        <label className="col-lg-4 col-form-label">OTP</label>
                        <div className="col-lg-8">
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            placeholder={`Enter OTP`}
                            required
                            value={otp}
                            onChange={(e) => setOTP(e.target.value)}
                          />
                          <a className={"cursor-pointer text-right"}>
                            Resend OTP
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger light"
                  data-bs-dismiss="modal"
                  onClick={() => setMobileModal(false)}>
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
